import { Outlet } from 'react-router-dom'
import { Footer, NavbarHeader, NavbarMenu } from 'src/components'
import { useDisclosure, useIsOnTopOfPage, useIsMobile } from 'src/utils'
import { useMainState } from 'src/store'
import { motion } from 'framer-motion'

const Navbar = () => {
  const user = useMainState((state) => state.user)
  const { isOpen: isMenuOpen, toggle: toggleMenu } = useDisclosure()
  const { isOnTopOfPage, ref } = useIsOnTopOfPage()
  const isMobile = useIsMobile()

  return (
    <motion.div
      initial='closed'
      animate={isMenuOpen ? 'opened' : 'closed'}
      className='w-screen h-screen overflow-hidden flex-column z-index-[500] gap-[10px] relative'
    >
      <NavbarHeader
        {...{ toggleMenu, isOnTopOfPage: !isMobile && isOnTopOfPage }}
      />
      <div
        ref={ref}
        className='w-full h-full overflow-x-hidden overflow-y-auto'
      >
        <Outlet />
        <Footer />
      </div>
      {isMobile && <NavbarMenu toggleMenu={toggleMenu} />}
    </motion.div>
  )
}

export default Navbar
